  export function mergeArrayAlternatively<T1, T2>(
    arr1: T1[] = [],
    arr2: T2[] = []
  ): (T1 | T2)[] {
    const result: (T1 | T2)[] = [];

    if(arr1.length === 0 && arr2.length === 0) return result;
    
    if(arr1.length === 0) {
      for(let i = 0; i < arr2.length; i++) {
        result.push(arr2[i]);
      }

      return result;
    } 

    if(arr2.length === 0) {
      for(let i = 0; i < arr1.length; i++) {
        result.push(arr1[i]);
      }

      return result;
    } 

    const minLength = Math.min(arr1.length, arr2.length);

    for (let i = 0; i < minLength; i++) {
      result.push(arr1[i]);
      result.push(arr2[i]);
    }

    return result;
  }
  
  export function mergeArrayAlternativelyV1<T1, T2>(
    arr1: T1[] = [],
    arr2: T2[] = []
  ): (T1 | T2)[] {
    const result: (T1 | T2)[] = [];
    const minLength = Math.min(arr1.length, arr2.length);

    for (let i = 0; i < minLength; i++) {
      result.push(arr1[i]);
      result.push(arr2[i]);
    }

    return result;
  }

